import Calculator from "./components/Calculator";

function App() {
	return (
		<div className="container">
			<Calculator />
			<div className="box footer">
				<small>
					&copy; 2021 <a href="https://www.jakobmaier.at">Jakob Maier</a>
				</small>
			</div>
		</div>
	);
}

export default App;
